import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useState } from 'react';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import ModalAtendimentoEncerrado from './ModalAtendimentoEncerrado';
import './styles.css';
import { sxButtonScheduleAction, sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';
import { fimAtendPaVirtual } from '../../../services/SaudeOnlineService';

const ModalEncerrarAtendimento: React.FC<{
    showModal: boolean;
    handleShowModal: () => void;
    idAgenda: string;
}> = ({ showModal, handleShowModal, idAgenda }) => {

    const [showModalAtendimentoEncerrado, setShowModalAtendimentoEncerrado] = useState<boolean>(false);
    const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const handleConfirmarEncerramentoAtendimento = async () => {
        handleShowModal();
        setShowLoading(true);
        let response = await fimAtendPaVirtual(idAgenda);
        setShowLoading(false);
        if (response?.status === 200) {
            handleShowAtendimentoEncerrado();
        } else {
            handleShowModalFeedBack();
        }
    }

    const handleShowAtendimentoEncerrado = () => {
        setShowModalAtendimentoEncerrado(showModalAtendimentoEncerrado => !showModalAtendimentoEncerrado);
    }

    const handleShowModalFeedBack = () => {
        setShowModalFeedBack(showModalFeedBack => !showModalFeedBack);
    }

    return (
        <div>
            <Modal
                open={showModal}
                onClose={handleShowModal}
            >
                <div className='container-schedule-modal' >
                    <IconButton
                        aria-label="Fechar"
                        onClick={handleShowModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <Typography sx={sxTypographyTitleModal}>Encerrar atendimento</Typography>
                        <Typography sx={sxTypographySubTitleModal}>Tem certeza que deseja encerrar seu atendimento?</Typography>
                    </div>
                    <div className='schedule-modal-buttons-holder'>
                        <Button onClick={handleShowModal} variant='outlined' sx={sxButtonScheduleAction}>
                            <Typography>Voltar</Typography>
                        </Button>
                        <Button onClick={handleConfirmarEncerramentoAtendimento} variant='contained' sx={sxButtonScheduleAction}>
                            <Typography>Encerrar</Typography>
                        </Button>
                    </div>
                </div>
            </Modal>
            <ModalAtendimentoEncerrado
                handleShowModal={handleShowAtendimentoEncerrado}
                showModal={showModalAtendimentoEncerrado}
            />
            <ModalFeedBack
                showModal={showModalFeedBack}
                handleButtonModal={handleShowModalFeedBack}
                showButtonModal
                icon='error'
                handleShowModal={handleShowModalFeedBack}
                textButton='Voltar'
                title='Erro'
                subTitle='Ocorreu um erro ao encerrar seu atendimento, tente novamente em alguns instantes.'
            />
            <LoadingApp showLoading={showLoading} />
        </div>
    );
};

export default ModalEncerrarAtendimento;
